import React from "react";
import "./Footer.css";
import { Form, InputGroup, NavLink } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faGoogle,
  faLinkedinIn,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { Link, useLocation, useNavigate } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const socialIcons = [
    { icon: faFacebookF, link: "https://www.facebook.com" },
    { icon: faGoogle, link: "https://www.google.com" },
    { icon: faXTwitter, link: "https://www.twitter.com" },
    { icon: faLinkedinIn, link: "https://www.linkedin.com" },
  ];

  const handleNavClick = (path, e) => {
    e.preventDefault();

    if (location.pathname === path) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate(path);
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 200);
    }
  };

  return (
    <section className="two_section_holder">
      <footer className="Footer">
        <div className="container">
          <div className="row ">
            {/* Logo */}
            <div className="col-lg-3 col-md-12 col-sm-12 mb-4">
              <div className="logo_holder">
                <img
                  src="/assets/images/logo/logo.png"
                  alt="Logo"
                  className="logo_img"
                />
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-lg-2 col-md-4 col-sm-4 col-6 mb-4 col_div">
              <h5 className="footer_section_title">Quick Links</h5>
              <div className="footer_links">
                {[
                  { label: "Home", path: "/" },
                  { label: "About Us", path: "/about-us" },
                  { label: "Services", path: "/services/maintenance" },
                  { label: "Contact Us", path: "/contact-us" },
                ].map((item) => (
                  <NavLink
                    key={item.path}
                    as={Link}
                    to={item.path}
                    onClick={(e) => handleNavClick(item.path, e)}
                    className={`footer_link ${
                      location.pathname === item.path ? "active" : ""
                    }`}
                  >
                    {item.label}
                  </NavLink>
                ))}
              </div>
            </div>

            {/* Follow Us */}
            <div className="col-lg-2 col-md-4 col-sm-4 col-6 mb-4 col_div">
              <h5 className="footer_section_title">Follow Us</h5>
              <div className="footer_links">
                {[
                  { label: "Facebook", link: "https://www.facebook.com" },
                  { label: "Twitter", link: "https://www.twitter.com" },
                  { label: "Instagram", link: "https://www.instagram.com" },
                  { label: "LinkedIn", link: "https://www.linkedin.com" },
                ].map((item, index) => (
                  <a
                    key={index}
                    href={item.link}
                    className="footer_link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {item.label}
                  </a>
                ))}
              </div>
            </div>

            {/* Support */}
            <div className="col-lg-2 col-md-4 col-sm-4 col-6 mb-4 col_div">
              <h5 className="footer_section_title">Support</h5>
              <div className="footer_links">
                <NavLink
                  as={Link}
                  to="/terms-conditions"
                  onClick={(e) => handleNavClick("/terms-conditions", e)}
                  className="footer_link"
                >
                  Terms & Conditions
                </NavLink>
                <NavLink
                  as={Link}
                  to="/privacy-policy"
                  onClick={(e) => handleNavClick("/privacy-policy", e)}
                  className="footer_link"
                >
                  Privacy Policy
                </NavLink>
              </div>
            </div>

            {/* Newsletter */}
            <div className="col-lg-3 col-md-12 col-6 col_div">
              {/* <h5 className="footer_section_title">Newsletter</h5> */}
              {/* <p className="newsletter_text">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non
                risus ipsum dolor sit amet, consectetur adipiscing elit.
              </p> */}

              <InputGroup className="mb-3 input-group">
                <Form.Control placeholder="Enter Email" aria-label="email" />
                <InputGroup.Text id="basic-addon2">
                  <div className="img_holder">
                    <img
                      src="/assets/images/footer/arrow.png"
                      className="arrow"
                      alt="submit arrow"
                    />
                  </div>
                </InputGroup.Text>
              </InputGroup>

              {/* social icons */}
              <div className="icons_holder">
                {socialIcons.map((item, index) => (
                  <div className="squr_box" key={index}>
                    <div className="icon_holder">
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="link"
                      >
                        <FontAwesomeIcon
                          icon={item.icon}
                          className="icon_class"
                        />
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer_text_div">
          <p className="footer_text">
            © 2025 Gravity Drive All Rights Reserved | Developed by{" "}
            <a
              href="https://profcymaglobal.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="link_text"
            >
              Profcyma Solutions Pvt Ltd
            </a>
          </p>
        </div>
      </footer>
    </section>
  );
};

export default Footer;
